var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0,
    d: "M0 0H70V70H0z",
    transform: "translate(-685.000000, -316.000000) translate(430.000000, 284.000000) translate(255.000000, 32.001200)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B5041E",
    d: "M47.93 45.699H4.07c-3.137 0-5.092-3.4-3.51-6.112L22.49 2.016c1.568-2.684 5.45-2.69 7.02 0l21.93 37.571c1.58 2.71-.37 6.112-3.51 6.112z",
    transform: "translate(-685.000000, -316.000000) translate(430.000000, 284.000000) translate(255.000000, 32.001200) translate(9.000000, 12.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC0020",
    d: "M25.47 3.754L3.54 41.326c-.24.41.053.924.53.924h43.86c.476 0 .771-.512.53-.924L26.53 3.754c-.237-.406-.822-.409-1.06 0z",
    transform: "translate(-685.000000, -316.000000) translate(430.000000, 284.000000) translate(255.000000, 32.001200) translate(9.000000, 12.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F4FBFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.892 15.612c1.013 0 1.87.843 1.87 1.841 0 .985-.857 1.818-1.87 1.818C.849 19.27 0 18.455 0 17.453c0-.998.866-1.841 1.892-1.841zM1.892 12.768c-1.05 0-1.782-.508-1.782-1.235V1.26C.11.65.826 0 1.892 0c.96 0 1.804.589 1.804 1.26v10.273c0 .715-.759 1.235-1.804 1.235z",
    transform: "translate(-685.000000, -316.000000) translate(430.000000, 284.000000) translate(255.000000, 32.001200) translate(9.000000, 12.000000) translate(24.119263, 17.610543)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#970016",
    d: "M2.654 39.587l21.93-37.571c.555-.95 1.437-1.612 2.462-1.88-1.71-.449-3.59.226-4.555 1.88L.56 39.587C-1.02 42.297.93 45.7 4.07 45.7h2.093c-3.137 0-5.092-3.4-3.51-6.112z",
    transform: "translate(-685.000000, -316.000000) translate(430.000000, 284.000000) translate(255.000000, 32.001200) translate(9.000000, 12.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#970016",
    d: "M5.632 41.326L27.046 4.638l-.515-.884c-.238-.407-.823-.408-1.062 0L3.54 41.326c-.24.41.054.924.531.924h2.093c-.476 0-.771-.512-.53-.924z",
    transform: "translate(-685.000000, -316.000000) translate(430.000000, 284.000000) translate(255.000000, 32.001200) translate(9.000000, 12.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#DAF1F4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.093 17.453c0-.622.337-1.184.839-1.52-.3-.202-.659-.321-1.04-.321-1.026 0-1.892.843-1.892 1.841 0 1.003.849 1.818 1.892 1.818.378 0 .735-.116 1.033-.313-.502-.327-.832-.88-.832-1.505zM2.203 11.533V1.26c0-.376.273-.767.732-1.012C2.635.094 2.274 0 1.892 0 .826 0 .11.651.11 1.26v10.273c0 .727.733 1.235 1.782 1.235.4 0 .756-.076 1.046-.21-.458-.214-.735-.578-.735-1.025z",
    transform: "translate(-685.000000, -316.000000) translate(430.000000, 284.000000) translate(255.000000, 32.001200) translate(9.000000, 12.000000) translate(24.119365, 17.610543)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanned);
export default __webpack_public_path__ + "static/media/banned.eb3abce9.svg";
export { ForwardRef as ReactComponent };